export default __webpack_public_path__ + "static/media/agendar_cita.7382ed70.jpeg";